import React from "react";
import * as palette from "@govlaunch/palette";

const Section: React.FunctionComponent = ({ children, ...props }) => {
  return (
    <div
      css={{
        borderRadius: 4,
        border: `solid 1px ${palette.lightestGray}`,
        backgroundColor: palette.white,
        overflow: "hidden",
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Section;
